import { Injectable } from '@angular/core';
import { HttpParams, HttpClient } from '@angular/common/http';
import { globals } from '../globals';

@Injectable({
  providedIn: 'root'
})
export class AnaliseDescontoConclusaoPositivaCampoPersonalizadoSelecionadoService {

  constructor(private http: HttpClient) { }

  salvar(campos, idAnaliseDesconto) {
    const body = {
      campos: campos,
      idAnaliseDesconto: idAnaliseDesconto
    };

    return this.http.post(globals.apiUrl + '/api/AnaliseDescontoConclusaoPositivaCampoPersonalizadoSelecionado/Salvar', body);
  }

  excluir(id) {
    return this.http.delete(globals.apiUrl + '/api/AnaliseDescontoConclusaoPositivaCampoPersonalizadoSelecionado/Excluir',
      { params: new HttpParams().set('id', id) });
  }

  montarParaCadastrar(idAnaliseDesconto) {
    return this.http.get<any>(globals.apiUrl + '/api/AnaliseDescontoConclusaoPositivaCampoPersonalizadoSelecionado/MontarParaCadastrar',
      { params: new HttpParams().set('idAnaliseDesconto', idAnaliseDesconto) });
  }
}
